import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  CreateUpdatePricingDto,
  GetPricingDto,
  GetPriceTypeDto,
  CreateUpdatePriceDtoConsultationTypeEnum,
} from '../autogenerated/spdApiClient';
import { pricingForGrid } from '../../../spd/components/Pricing/Pricing';
import { GridRecord } from '../../components/Grid/GridDataTypes';

export interface PricingContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: 'ASC' | 'DESC',
    filterText?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string) => Promise<number>;
  getById: (id: string) => Promise<GetPricingDto>;
  createWithPricelist: (dto: CreateUpdatePricingDto) => Promise<GetPricingDto>;
  updateWithPricelist: (
    id: string,
    dto: CreateUpdatePricingDto,
  ) => Promise<GetPricingDto>;
  pricingControllerGetAllCombinations: () => Promise<GetPriceTypeDto[]>;
}

export const PricingContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: 'ASC' | 'DESC',
      filterText?: string,
    ) => {
      const data = await api.pricingControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
      );
      return data.map(pricingForGrid);
    },

    getAllCount: async (filterText?: string) => {
      return await api.pricingControllerGetAllCount(filterText);
    },

    getById: async (id: string) => {
      const pricing = await api.pricingControllerGetById(id);
      // Ensure prices array exists if not provided by API
      if (pricing && !pricing.prices) {
        pricing.prices = [];
      }
      return pricing;
    },

    createWithPricelist: (dto: CreateUpdatePricingDto) =>
      api.pricingControllerCreateWithPricelist(dto),

    updateWithPricelist: (id: string, dto: CreateUpdatePricingDto) =>
      api.pricingControllerUpdateWithPricelist(id, dto),

    pricingControllerGetAllCombinations: () =>
      api.pricingControllerGetAllCombinations(),
  };
};

export const pricingData = (
  pricing?: GetPricingDto | undefined,
): CreateUpdatePricingDto => {
  if (!pricing) {
    return { name: '', prices: [], startDate: new Date() };
  }
  return {
    ...pricing,
    prices: pricing?.prices?.map(price => ({
      ...price,
      consultationType:
        price.consultationType as unknown as CreateUpdatePriceDtoConsultationTypeEnum,
    })),
  };
};
